import { render } from "./SkippersList.vue?vue&type=template&id=3d0ecc59"
import script from "./SkippersList.vue?vue&type=script&lang=js"
export * from "./SkippersList.vue?vue&type=script&lang=js"

import "./SkippersList.vue?vue&type=style&index=0&id=3d0ecc59&lang=css"
script.render = render

export default script